import { render } from "./WarehouseDatatableTDMaterialValue.vue?vue&type=template&id=effa2c26"
import script from "./WarehouseDatatableTDMaterialValue.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDMaterialValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__